
/**
 * Takes a timestamp string and returns how long ago that was in human readable german.
 *
 Expected input format is `2026-07-21T10:14:20.649`, so ISO/JSON timestamp WITHOUT the Z at the end.
 *
 * @export
 * @param {string} date as above
 * @returns {string} a human readable timeAgo string in German
 */
export function timeAgo(date: string) {
  const seconds = Math.floor((Date.now() - new Date(date).getTime()) / 1000);
  const rtf = new Intl.RelativeTimeFormat('de', { numeric: 'auto' });

  const intervals = {
    year: 31536000,
    month: 2592000,
    week: 604800,
    day: 86400,
    hour: 3600,
    minute: 60
  };

  for (const [unit, secondsInUnit] of Object.entries(intervals)) {
    const interval = Math.floor(seconds / secondsInUnit);
    if (interval >= 1) {
      return rtf.format(-interval, unit as Intl.RelativeTimeFormatUnit);
    }
  }
  return rtf.format(-seconds, 'second');
}
